// redux/slices/userStatisticsSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getUserStatistics } from '../../api/api';

export const fetchUserStatistics = createAsyncThunk(
  'userStatistics/fetchUserStatistics',
  async (uid, { rejectWithValue }) => {
    try {
      const res = await getUserStatistics(uid);
      return res;
    } catch (err) {
      console.error('fetchUserStatistics error:', err);
      return rejectWithValue(err.response?.data || 'Error fetching statistics');
    }
  }
);

const userStatisticsSlice = createSlice({
  name: 'userStatistics',
  initialState: {
    stats: null,
    loading: false,
    error: null,
  },
  reducers: {
    clearUserStatistics: (state) => {
      state.stats = null;
      state.error = null;
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserStatistics.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUserStatistics.fulfilled, (state, action) => {
        state.loading = false;
        state.stats = action.payload;
      })
      .addCase(fetchUserStatistics.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to fetch user statistics';
      });
  },
});

export const { clearUserStatistics } = userStatisticsSlice.actions;
export default userStatisticsSlice.reducer;
